export default __webpack_public_path__ + "static/bunker_security_upgrade-85b9197efd92165b9830163d580586a5.png";